import type { CampaignStepEntity } from './CampaignStepEntity'
import type { CampaignTranslationAdminDto } from '@/backend/market/models/CampaignTranslationAdminDto'

export class CampaignsEntity {
  createdAt?: string
  updatedAt?: string
  id?: number
  startDate?: string
  endDate?: string
  steps?: Array<CampaignStepEntity> | null
  priority?: number | null
  isActive?: boolean
  translations?: Array<CampaignTranslationAdminDto> | null
  atNumberOfOrders?: Array<number> | null
  maxUsage?: number | null
  maxUserUsage?: number | null
}
